import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import PreLoginApi from '../../../components/Api/PreLoginApi';
import preLoginGetApi from '../../../components/Api/PreLoginGetApi';
import FooterContact from '../FooterContact';


const StepFive = () => {
    let navigate = useNavigate();
    const [data, setData] = useState({});
    
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const [input, setInput] = useState({});
    useEffect(()=>{
        const tokenParam = new URLSearchParams(window.location.search).get('token')?.toString().replaceAll(" ","+");
        if( tokenParam === null || tokenParam === undefined || tokenParam === "" ) {
            return navigate("/");
        }

        // Now Check by API call
        try {
            PreLoginApi("panel/company-registration-request/validateToken",JSON.stringify({token: tokenParam})).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                    return navigate("/");
                }
                
                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);

                if (data["code"] === 200) {
                    setData(data["data"]);

                    const step4 = JSON.parse(data["data"]?.step4);
                    if( step4?.name?.length > 0 ) {
                        $("#thank_you_div").show();
                        $("#form").hide();
                        return;
                    }


                    setInput({...input, token: tokenParam});
                    return;
                }


                // redirect to login page
                toast.error(data["messages"]);
                return navigate("/company-registration-step-three?token="+tokenParam);

            }).catch((error) => {
                toast.error(error);
            });
        }
        catch (err) {
            toast.error(err);
            console.log(err);
        }

    },[]);


    const handleSubmit = event => {
        event.preventDefault();

        // Now call API to store and proceed to next
        if(input.name?.length === 0 || input.address?.length === 0 || input.email_address?.length === 0) {
            toast.error("Please fill up all fields with * sign.");
            return;
        }


        if(!isValidEmail(input.email_address)) {
            toast.error("Please enter valid Email Address.");
            return;
        }


        // Now Call API
        PreLoginApi("panel/company-registration-request/step4", JSON.stringify(input)).then((responseJSON) => {
            var response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if( response["status"] === 0 ) {
                toast.error("A problem occur. Please try again.");
                return;
            }
            
            let responseData = JSON.stringify(response["data"]);
            responseData = JSON.parse(responseData);

            if (responseData["code"] === 200) {
                $("#thank_you_div").show();
                $("#form").hide();
                return;
            }

            toast.error(responseData["messages"]);
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        });
    }

    
    const handleChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;

        setInput({...input, [name] : value});
    }


    useEffect(()=>{
        $('#submit_btn').css({ opacity: '0.6' });
        $('#submit_btn').attr("disabled", true);
        
        if(input.name?.length > 0 && input.address?.length > 0 && input.email_address?.length > 0) {

            if(!isValidEmail(input.email_address)) {
                return;
            }

            $('#submit_btn').css({ opacity: '1' });
            $('#submit_btn').attr("disabled", false);
        }

    },[input]);






    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className="flex h-full flex-wrap items-center justify-center lg:justify-center">


                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
                                <div className="py-6 px-2 sm:py-10 sm:px-6">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="mb-6 font-semibold leading-8 text-white text-[25px] dark:text-white">
                                        ShareTrip Partner Registration
                                    </p>
                                    

                                    <span id="thank_you_div" className='hidden'>
                                        <div className='text-white text-sm mb-1 ml-1'>
                                            <p className='font-semibold text-[18px] mb-2'>Thank You</p>
                                            <div className='mt-1 mb-4 mr-2'>
                                                
                                                <p className='text-[15px] text-justify'>Your ShareTrip Partner Registration has been submitted successfully. Our team will review your application and you can expect approval within the next 72 hours.</p>
                                                
                                                <p className='text-[15px] text-justify mt-2'>A dedicated representative from ShareTrip will contact you shortly to discuss the next steps and provide any necessary assistance.</p>

                                                <p className='text-[15px] text-justify mt-2'>Thank you for choosing ShareTrip as your partner. We look forward to a successful collaboration.</p>
                                            </div>
                                        </div>

                                        <Link to={"/"} className="block btn w-full mt-8 mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-100">Back to login</Link>
                                    </span>


                                    
                                    <form id="form" onSubmit={handleSubmit} method="POST">
                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Company Name (As per trade license)</p>
                                        <div className='mb-3'>
                                            <input type="text" name="account_name" autoComplete='off' disabled={true} value={data.company_name ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Account Name (Same as company name)" required={true} />
                                        </div>

                                        <p className='font-semibold mb-2 pt-0.5 pb-1 px-1 text-[16px] text-white rounded-md' style={{border: "2px dotted #FFF"}}>
                                            MD/Chairman/Director/Owners/Partner's Info
                                        </p>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Full Name *</p>
                                        <div className='mb-2'>
                                            <input type="text" name="name" autoComplete='off' value={input.name ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Full Name" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Address *</p>
                                        <div className='mb-2'>
                                            <input type="text" name="address" autoComplete='off' value={input.address ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Address" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Email Address *</p>
                                        <div className='mb-2'>
                                            <input type="email" name="email_address" autoComplete='off' value={input.email_address ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Email Address" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Phone Number</p>
                                        <div className='mb-2'>
                                            <input type="text" name="phone" autoComplete='off' value={input.phone ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Phone Number" />
                                        </div>

                                        

                                        
                                        <button id="submit_btn" disabled={true} className="btn mt-4 w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60 disabled:cursor-not-allowed">
                                            Next
                                        </button>


                                        {/* <p className='text-white text-sm text-right mr-1'>
                                            <span onClick={cancelProceed} className="cursor-pointer text-sm font-medium text-white text-right ml-1">
                                                Register Later ?
                                            </span>
                                        </p> */}

                                    </form>
                                    
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepFive;